import { InputLabel, MenuItem, Select } from '@mui/material'
import React, { useMemo } from 'react'
import { useUsRoleTypeLuts } from 'components'
import { type Role } from 'services'
import { US_GENERAL_BRANCHES } from 'utils'

export interface RoleSelectProps {
  value: Role | null
  updateRole: (type: Role | null) => void
  getRoleFilter: (roles: Role[]) => Role[]
  disabled: boolean
  label?: string
  updateBranch?: (branch: { id: string, desc: string } | null) => void
}

export const RoleSelect: React.FC<RoleSelectProps> = ({
  value,
  updateRole,
  getRoleFilter,
  disabled,
  label = 'Role Type',
  updateBranch
}) => {
  const { lutValues: roleTypeLutValues } = useUsRoleTypeLuts()
  const availableRoles = useMemo<Role[]>(() => {
    const roles = Array.from(roleTypeLutValues.roles.values())
    const filteredRoles = getRoleFilter(roles)
    return filteredRoles.sort((a: Role, b: Role) =>
      a.desc.localeCompare(b.desc)
    )
  }, [roleTypeLutValues.roles, getRoleFilter])

  const handleChange = (value: string | number): void => {
    if (value !== '') {
      const selectedRole = roleTypeLutValues.roles.get(Number(value)) ?? null
      updateRole(selectedRole)

      if ((updateBranch != null) && (selectedRole != null)) {
        const executiveBranchIds = [US_GENERAL_BRANCHES.FEDERAL_EXECUTIVE_BRANCH, US_GENERAL_BRANCHES.STATE_EXECUTIVE_BRANCH]
        const isExecutive = executiveBranchIds.includes(selectedRole.branch.id)

        updateBranch({
          id: isExecutive ? 'executive' : 'legislative',
          desc: isExecutive ? 'Executive' : 'Legislative'
        })
      }
    } else {
      updateRole(null)
      if (updateBranch != null) {
        updateBranch(null)
      }
    }
  }

  return (
    <React.Fragment>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        id='role-select'
        value={value?.id ?? ''}
        disabled={disabled}
        onChange={(event) => { handleChange(event.target.value) }}
      >
        <MenuItem value=''>None</MenuItem>
        {availableRoles.map(value => (
          <MenuItem key={value.id} value={value.id}>{value.desc}</MenuItem>
        ))}
      </Select>
    </React.Fragment>
  )
}
